import React, { useState } from 'react';
import { X } from '@phosphor-icons/react';

const CancelRemarkModal = ({ isOpen, onClose, onSubmit, request }) => {
  const [remark, setRemark] = useState('');
  const [submitting, setSubmitting] = useState(false);

  if (!isOpen || !request) return null;

  const handleSubmit = async (e) => {
    e?.preventDefault();
    if (!remark.trim()) return;
    setSubmitting(true);
    try {
      await onSubmit(request, remark.trim());
      setRemark('');
      onClose();
    } catch (err) {
      console.error(err);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-[120] p-4 backdrop-blur-[2px]">
      <div className="bg-wa-panel rounded-xl shadow-2xl max-w-sm w-full border border-wa-border overflow-hidden text-wa-text-primary animate-fade-in">
        {/* Top Header */}
        <div className="bg-[#ea0038] px-4 py-3 flex items-center justify-between text-white font-semibold shadow-sm">
          <div className="flex items-center gap-2">
            <span>❌</span>
            <span>Cancel Request ({request.form_id || request.formNo || 'Request'})</span>
          </div>
          <button onClick={onClose} className="p-1 hover:bg-white/10 rounded-full text-white">
            <X size={18} weight="bold" />
          </button>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} className="p-5 space-y-4">
          <div>
            <label className="block text-xs font-semibold text-wa-text-secondary uppercase mb-1">
              Reason / Remark *
            </label>
            <textarea
              value={remark}
              onChange={(e) => setRemark(e.target.value)}
              placeholder="Enter reason for cancellation..."
              className="w-full border border-wa-border rounded-lg p-2.5 text-sm bg-wa-hover outline-none focus:border-[#ea0038] resize-none h-24 text-wa-text-primary"
              required
              autoFocus
            />
          </div>

          <div className="flex gap-2">
            <button
              type="button"
              onClick={onClose}
              className="flex-1 py-2 border border-wa-border rounded-lg text-xs font-semibold text-wa-text-secondary hover:bg-wa-hover"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={submitting || !remark.trim()}
              className="flex-1 py-2 bg-[#ea0038] hover:bg-[#c2002f] text-white font-bold rounded-lg text-xs transition-all active:scale-[0.98] disabled:opacity-50"
            >
              {submitting ? 'Submitting...' : 'Submit Remark'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CancelRemarkModal;
